import { useEffect, useState } from 'react';
import { finApi } from '../../api/finance.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Vendors() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const canCreate = can('vendor', 'create');

  function refresh() { finApi.vendors().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const contact = { email: fd.get('contactEmail') || null, phone: fd.get('contactPhone') || null };
    await finApi.createVendor({
      name: fd.get('name'),
      taxId: fd.get('taxId') || null,
      paymentTerms: Number(fd.get('paymentTerms') || 30),
      contact,
      bankDetails: {},
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Vendors</h1>
        {canCreate && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Vendor'}</button>}
      </header>

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" required /></label>
          <label>Tax ID<input name="taxId" /></label>
          <label>Payment Terms (days)<input name="paymentTerms" type="number" defaultValue={30} /></label>
          <label>Contact Email<input name="contactEmail" type="email" /></label>
          <label>Contact Phone<input name="contactPhone" /></label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>Tax ID</th><th>Payment Terms</th><th>Contact</th><th>Status</th></tr></thead>
          <tbody>
            {items.map((v) => {
              const c = typeof v.contact === 'string' ? JSON.parse(v.contact) : v.contact || {};
              return (
                <tr key={v.id}>
                  <td><strong>{v.name}</strong></td>
                  <td className="muted">{v.tax_id || '—'}</td>
                  <td>Net {v.payment_terms}</td>
                  <td className="muted">{c.email || c.phone || '—'}</td>
                  <td><span className={`chip status-${v.is_active ? 'active' : 'cancelled'}`}>{v.is_active ? 'active' : 'inactive'}</span></td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan={5} className="muted">No vendors yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
